var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-actions-menu"},[_c('ElementMenuLink',{attrs:{"id":_vm.item.id,"loading":_vm.loading}}),_c('ElementMenuList',{attrs:{"id":_vm.item.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }